import {SHOP_HOME, TENANTS} from "../../Config/ApiUrl";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import AppFunction from "../../../core/helpers/app/AppFunction";

export default {
    // mixins: [],
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        function asset(path) {
            return `${window.location.origin}/${path}`;
        }
        return {
            isLocationModalActive: false,
            isLocationCreateOpenModalActive: false,
            selectedUrl: '',
            promptIcon: '',
            employeeId: '',
            modalClass: '',
            isModalActive: false,
            options: {
                showSearch: true,
                showFilter: true,
                // cardViewComponent: 'app-package-card-view',
                name: this.$allLabel('shop'),
                url: SHOP_HOME,
                showCount: true,
                showClearFilter: true,
                responsive: true,
                showAction: true,
                actionType: "default",
                enableRowSelect: false,
                columns: [
                    {
                        title: this.$t('title'),
                        type: 'custom-html',
                        key: 'title',
                        isVisible: true,
                        modifier: (title) => {
                            return title ? title: '-';
                        }
                    },
                    {
                        title: this.$t('description'),
                        type: 'custom-html',
                        key: 'description',
                        isVisible: true,
                        modifier: (description) => {
                            return description ? description: '-';
                        }
                    },
                    {
                        title: this.$t('price'),
                        type: 'custom-html',
                        key: 'price',
                        isVisible: true,
                        modifier: (price) => {
                            return price ?? '';
                        }
                    },
                    {
                        title: this.$t('stock'),
                        type: 'custom-html',
                        key: 'stock',
                        isVisible: true,
                        modifier: (stock) => {
                            return stock ?? 0;
                        }
                    },
                    {
                        title: this.$t('image'),
                        type: 'custom-html',
                        key: 'image',
                        isVisible: true,
                        modifier: (image) => {
                            if (image)
                                return `<div style="background-image: url(${window.location.origin + image}); background-position: center; background-size: cover;width: 100%;height: 80px;border-radius: 5px;" />`;
                                //return `<img src="${image}" alt="demo crm" style="max-width: 100px;"/>`;
                                //return `<img src="${image}" alt="demo crm" style="max-width: 100px;"/>`;
                            else
                                return `<div style="background-image: url(${window.location.origin + 'images/placeholder_img.png'}); background-position: center; background-size: cover;width: 100%;height: 80px;border-radius: 5px;" />`;
                                //return `<img src="${ asset('images/placeholder_img.png') }" alt="product placeholder" style="max-width: 100px;"/>`
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        isVisible: true,
                        modifier: status => {
                            return `<span class="badge badge-pill text-capitalize text-${status === 'available' ? 'success' : 'danger'} badge-${status === 'active' ? 'active' : 'inactive'}">
                                ${status}
                            </span>`
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                rowLimit: 10,
                paginationType: "pagination",
                actions: [
                    {
                        title: this.$t('edit'),
                        // url: GET_ALL_LOCATIONS,
                        icon: 'edit',
                        key: "edit",
                        modifier: row => {
                            return this.$can('update_crms') && (row.id !== window.user.id || this.$isAdmin() || this.$isTenantAdmin());
                        },
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        url: SHOP_HOME,
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        name: 'delete',
                        modifier: row => {
                            return this.$can('delete_crms') && (row.id !== window.user.id || this.$isAdmin() || this.$isTenantAdmin());
                        },
                    }
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "created_at",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('name'),
                        key: "name",
                        type: "text",
                    },
                ]
            },
            selectedEmployees: [],
            isContextMenuOpen: false,
        }
    },
    methods: {
        openLocationModal() {
            this.isLocationModalActive = true;
        },
        setFilterValues(filterValue) {
            if (filterValue.date_range && typeof filterValue.date_range != 'string') {
                filterValue.date_range = JSON.stringify(filterValue.date_range)
            }
            this.$store.dispatch('updateFilterObject', filterValue)
        },
        setSearchValue(search) {
            this.$store.dispatch('updateFilterObject', {search: search})
        },
        getSelectedRows(data, isSelectedAll) {
            this.selectedEmployees = data;
            this.isContextMenuOpen = data.length;
        },
        triggerActions(row, action, active) {


            // if (action.key === 'view_details') {
            //     window.location = urlGenerator(`${EMPLOYEES_PROFILE}/${this.employeeId}/profile`);
            // }

            if (action.key === 'edit') {
            }

        },
        reloadShopTable() {
            this.isContextMenuOpen = false;
            this.$hub.$emit('reload-shop-table')
        },
    }
}